import * as actionTypes from './actionTypes';

export const setCanNavigate = (canNavigate) => {
    return {
        type: actionTypes.navigation.SET_CAN_NAVIGATE,
        canNavigate,
    };
};
